import { DateTime } from 'luxon';

export const unresolvedSteps = (plan) =>
	(plan.steps || []).filter((step) => ['OPEN', 'PREPARING', 'UPCOMING'].includes(step.state));

export const nextStep = (plan) => unresolvedSteps(plan)[0] || null;

export const triggerLabel = (i18n, step) => {
	if (!step) return '';
	if (step.state === 'OPEN' && step.dateDue) {
		return i18n.t('payment-plans.due-date', { date: localizedDate(i18n.locale, step.dateDue) });
	}
	if (step.triggerType === 'Date' && step.triggerDate) {
		return i18n.t('payment-plans.invoice-expected', { date: localizedDate(i18n.locale, step.triggerDate) });
	}
	if (step.triggerType === 'Milestone') return i18n.t('payment-plans.when-milestone');
	if (step.triggerType === 'Immediate') return i18n.t('payment-plans.after-signing');
	if (step.triggerType === 'RelativeDate') {
		const count = Number(step.relativeTriggerDate && step.relativeTriggerDate.duration) || 1;
		const unit = String((step.relativeTriggerDate && step.relativeTriggerDate.timeUnit) || 'DAYS').toLowerCase();
		return i18n.t('payment-plans.after-signing-period', {
			period: i18n.tc(`global.${unit}`, count, { count }),
		});
	}
	return i18n.t('payment-plans.date-not-set');
};

export const paymentTermsLabel = (i18n, paymentDays) => {
	if (paymentDays === 0) return i18n.t('payment-plans.due-on-receipt');
	if (paymentDays === -1) return i18n.t('payment-plans.due-first-next-month');
	if (paymentDays === -2) return i18n.t('payment-plans.due-fifteenth-next-month');
	const count = Number(paymentDays) || 7;
	return i18n.t('payment-plans.due-days', { count });
};

export const localizedDate = (locale, date) =>
	DateTime.fromISO(date).setLocale(locale).toLocaleString(DateTime.DATE_MED);
